export default "__VITE_ASSET__BNx7YrzS__"